import { Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface SearchButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const SearchButton: React.FC<SearchButtonProps> = ({ onClick, disabled = false }) => {

  return (
    <Button
      variant="contained"
      startIcon={<SearchIcon />}
      onClick={onClick}
      disabled={disabled}
      sx={{
        bgcolor: "primary.main",
        "&:hover": {
          bgcolor: "primary.dark",
        },
      }}
    >
      ค้นหา
    </Button>
  );
};

export default SearchButton;
